import React, { useState } from 'react';
import './PhotoGallery.css';

const PhotoGallery = ({ photos, baseUrl = '' }) => {
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  if (!photos || photos.length === 0) {
    return null;
  }

  const getFullUrl = (photoUrl) => {
    if (photoUrl.startsWith('http')) {
      return photoUrl;
    }
    const apiBaseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';
    return `${apiBaseUrl}${photoUrl}`;
  };

  const openLightbox = (index) => {
    setSelectedPhoto(index);
  };

  const closeLightbox = () => {
    setSelectedPhoto(null);
  };

  const navigatePhoto = (direction) => {
    if (direction === 'prev') {
      setSelectedPhoto((prev) => (prev > 0 ? prev - 1 : photos.length - 1));
    } else {
      setSelectedPhoto((prev) => (prev < photos.length - 1 ? prev + 1 : 0));
    }
  };

  return (
    <div className="photo-gallery">
      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => openLightbox(index)}
          >
            <img
              src={getFullUrl(photo)}
              alt={`${index + 1}`}
              loading="lazy"
            />
          </div>
        ))}
      </div>

      {selectedPhoto !== null && (
        <div className="lightbox" onClick={closeLightbox}>
          <button className="lightbox-close" onClick={closeLightbox}>
            ×
          </button>
          <button
            className="lightbox-nav lightbox-prev"
            onClick={(e) => {
              e.stopPropagation();
              navigatePhoto('prev');
            }}
          >
            ‹
          </button>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img
              src={getFullUrl(photos[selectedPhoto])}
              alt={`${selectedPhoto + 1}`}
            />
            <div className="lightbox-counter">
              {selectedPhoto + 1} / {photos.length}
            </div>
          </div>
          <button
            className="lightbox-nav lightbox-next"
            onClick={(e) => {
              e.stopPropagation();
              navigatePhoto('next');
            }}
          >
            ›
          </button>
        </div>
      )}
    </div>
  );
};

export default PhotoGallery;

